import { API, TOKEN_NAME } from "./Constants";

class QueryService {
  static get(path) {
    const token = localStorage.getItem(TOKEN_NAME);

    return fetch(API + path, {
      headers: {
        "content-type": "application/json",
        "X-ADMINUSER-TOKEN": token,
      },
    }).then(async (response) => {
      if (response.ok) {
        return response.json();
      } else {
        // Try to extract error message from response body
        let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.error) {
            errorMessage = errorData.error;
          } else if (errorData.errors) {
            errorMessage =
              typeof errorData.errors === "string"
                ? errorData.errors
                : JSON.stringify(errorData.errors);
          } else if (errorData.message) {
            errorMessage = errorData.message;
          }
        } catch (e) {
          // If response is not JSON, use status text
        }

        const error = new Error(errorMessage);
        error.status = response.status;
        error.statusText = response.statusText;
        throw error;
      }
    });
  }

  static post(path, body) {
    const token = localStorage.getItem(TOKEN_NAME);

    return fetch(API + path, {
      headers: {
        "content-type": "application/json",
        "X-ADMINUSER-TOKEN": token,
      },
      body: JSON.stringify(body),
      method: "post",
    }).then(async (response) => {
      if (response.ok) {
        return response.json();
      } else {
        // Try to extract error message from response body
        let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.error) {
            errorMessage = errorData.error;
          } else if (errorData.errors) {
            errorMessage =
              typeof errorData.errors === "string"
                ? errorData.errors
                : JSON.stringify(errorData.errors);
          } else if (errorData.message) {
            errorMessage = errorData.message;
          }
        } catch (e) {
          // If response is not JSON, use status text
        }

        const error = new Error(errorMessage);
        error.status = response.status;
        error.statusText = response.statusText;
        throw error;
      }
    });
  }

  static postForm(path, body) {
    const token = localStorage.getItem(TOKEN_NAME);

    return fetch(API + path, {
      headers: {
        "X-ADMINUSER-TOKEN": token,
      },
      body: body,
      method: "post",
    }).then(async (response) => {
      if (response.ok) {
        return response.json();
      } else {
        // Try to extract error message from response body
        let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.error) {
            errorMessage = errorData.error;
          } else if (errorData.errors) {
            errorMessage =
              typeof errorData.errors === "string"
                ? errorData.errors
                : JSON.stringify(errorData.errors);
          } else if (errorData.message) {
            errorMessage = errorData.message;
          }
        } catch (e) {
          // If response is not JSON, use status text
        }

        const error = new Error(errorMessage);
        error.status = response.status;
        error.statusText = response.statusText;
        throw error;
      }
    });
  }

  static put(path, body) {
    const token = localStorage.getItem(TOKEN_NAME);

    return fetch(API + path, {
      headers: {
        "content-type": "application/json",
        "X-ADMINUSER-TOKEN": token,
      },
      body: JSON.stringify(body),
      method: "put",
    }).then(async (response) => {
      if (response.ok) {
        return response;
      } else {
        // Try to extract error message from response body
        let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.error) {
            errorMessage = errorData.error;
          } else if (errorData.errors) {
            errorMessage =
              typeof errorData.errors === "string"
                ? errorData.errors
                : JSON.stringify(errorData.errors);
          } else if (errorData.message) {
            errorMessage = errorData.message;
          }
        } catch (e) {
          // If response is not JSON, use status text
        }

        const error = new Error(errorMessage);
        error.status = response.status;
        error.statusText = response.statusText;
        throw error;
      }
    });
  }

  static deleteResource(path) {
    const token = localStorage.getItem(TOKEN_NAME);

    return fetch(API + path, {
      headers: {
        "content-type": "application/json",
        "X-ADMINUSER-TOKEN": token,
      },
      method: "delete",
    })
      .then(async (response) => {
        if (response.ok) {
          return response;
        } else {
          // Try to extract error message from response body
          let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
          try {
            const errorData = await response.json();
            if (errorData.error) {
              errorMessage = errorData.error;
            } else if (errorData.errors) {
              errorMessage =
                typeof errorData.errors === "string"
                  ? errorData.errors
                  : JSON.stringify(errorData.errors);
            } else if (errorData.message) {
              errorMessage = errorData.message;
            }
          } catch (e) {
            // If response is not JSON, use status text
          }

          const error = new Error(errorMessage);
          error.status = response.status;
          error.statusText = response.statusText;
          throw error;
        }
      })
      .catch((error) => {
        // If this is already an error we threw above, re-throw it
        if (error.status) {
          throw error;
        }

        // Handle network errors (CORS, network unavailable, etc.)
        const networkError = new Error("Failed to fetch: " + error.message);
        networkError.isNetworkError = true;
        throw networkError;
      });
  }
}

export default QueryService;



// WEBPACK FOOTER //
// ./src/QueryService.js